/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_UnpaidInputs */

const vi_dashboard_unpaid = /** @type {(inputs: Dashboard_UnpaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa thanh toán`)
};

/**

* @param {Dashboard_UnpaidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_unpaid = /** @type {((inputs?: Dashboard_UnpaidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_UnpaidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_unpaid(inputs)
});